import ArrowBtn from 'components/buttons/ArrowBtn'
import useTranslation from 'hooks/useTranslation'
import { useHistory } from 'react-router-dom'
import Popup from 'components/popups/Popup'

const InfoMagbox = ({ cancelAction }) => {
  const { goBack } = useHistory()
  const { t } = useTranslation('newWarehouse')

  return (
    <Popup close={cancelAction || goBack}>
      <div className='popup__title'>
        <div>Magbox</div>
      </div>
      <div className='popup__infoBlocks'>
        <span className='desc'>
          {t('informationAboutWhatMagboxLooksLikeAndHowItWorks')}
        </span>
        <ArrowBtn
          enlarged
          showArrow={false}
          text={t('iUnderstand')}
          action={cancelAction || goBack} />
      </div>
    </Popup>
  )
}

export default InfoMagbox